import styled from '@emotion/styled'
import { css } from '@emotion/react'
export const StyledWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  background: ${(props) =>
    props.bg ? props.theme.colors[props.bg] : 'transparent'};
  row-gap: ${(props) => (props.rowGap ? props.rowGap : 0)}px;
  ${(props: any) => css`
    ${props?.alignItems && `align-items: ${props.alignItems};`}
    ${props?.justifyContent && `justify-content: ${props.justifyContent};`}
  `}
  ${(props) => props.styleColumn};
`
